var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-bg"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-main"},[_vm._t("default")],2),_c('div',{staticClass:"modal-footer"},[_c('i',{staticClass:"el-icon-circle-close text-white fs20",on:{"click":_vm.hideModal}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }